<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-09-19 15:33:13
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container" >
    <div class="btnBox">
      <el-button type="primary" @click="addDeliver()">添加发货单</el-button>
      <el-button type="primary" @click="importData()">批量导入</el-button>
    </div>
    <el-form ref="form" :model="form" label-width="95px" :inline="true" class="mt20">
      <el-form-item label="发货时间:" style="text-align: center">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="form.start_time"
            style="width: 100%;"
            clearable
          ></el-date-picker>
        </el-col>
        <el-col :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="结束时间"
            v-model="form.end_time"
            style="width: 100%;"
            clearable
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="生产批次号:">
        <el-input v-model="form.production_batch" clearable></el-input>
      </el-form-item>
      <el-form-item label="发货单号:">
        <el-input v-model="form.stock_out_sn" clearable></el-input>
      </el-form-item>
      <el-form-item label="产品编号:">
        <el-input v-model="form.product_sn" clearable></el-input>
      </el-form-item>

      <el-form-item label="产品名称:">
        <el-input v-model="form.product_name" clearable></el-input>
      </el-form-item>

      <el-form-item label="发货仓库:" prop="region">
        <el-select v-model="form.warehouse_sn">
          <el-option key label="全部" value></el-option>
          <el-option
            v-for=" i in stockArray"
            :key="i.warehouse_sn"
            :label="i.warehouse_name"
            :value="i.warehouse_sn"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态:">
        <el-select v-model="form.status" clearable placeholder="请选择">
          <el-option key label="全部" value></el-option>
          <el-option key="0" label="未发货" value="0"></el-option>
          <el-option key="1" label="待收货" value="1"></el-option>
          <el-option key="2" label="发货中" value="2"></el-option>

          <el-option key="6" label="已完成" value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经销商/门店:">
        <el-col :span="12">
          <el-input v-model="form.to_sn" clearable></el-input>
        </el-col>
        <el-col :span="4" style="margin-left: 10px;">
          <el-button type="primary" @click="selectType()">选择</el-button>
        </el-col>
      </el-form-item>
      <el-form-item label="是否赠品:" prop="region">
        <el-select clearable v-model="form.isgift">
          <el-option label="全部" value></el-option>
          <el-option label="赠品" value="1"></el-option>
          <el-option label="非赠品" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="发货单类型:" prop="region">
        <el-select clearable v-model="form.type">
          <el-option label="全部" value="0"></el-option>
          <el-option label="自建发货单" value="1"></el-option>
          <el-option label="在线订单发货单" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="form.type == 2" label="在线订单号:">
        <el-input v-model="form.order_line_no" clearable></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSearch()">搜索</el-button>
        <el-button @click="exportData()">导出</el-button>
      </el-form-item>
    </el-form>
    <!--表格-->
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;padding-bottom:50px;overflow: visible;"
      border
      fit
       max-height="500"
      >
      <!-- <el-table-column prop="id" label="序号" sortable fixed="left"></el-table-column> -->
      <el-table-column prop="stock_out_sn" label="发货单号" fixed="left" width="130"></el-table-column>
      <el-table-column prop="stock_out_time" label="日期" fixed="left" width="150"></el-table-column>
      <el-table-column prop="to_sn" label="经销商/门店编号" width="140"></el-table-column>
      <el-table-column prop="to_name" label="经销商/门店名称" width="180"></el-table-column>
      <el-table-column prop label="是否赠品" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.isgift == 1">赠品</span>
          <span v-if="scope.row.isgift == 2">非赠品</span>
        </template>
      </el-table-column>
      <el-table-column prop="total_stock_out_num" label="应发数量" >
        <template slot-scope="scope">
          <!-- {{scope.row}} -->
            <span
            @click="deliverDetail(scope.row)"
            style="color:red;cursor: pointer;"
          >{{scope.row.stock_out_sn?scope.row.total_stock_out_num:""}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="total_real_stock_out_num" label="实发数量">
         <template slot-scope="scope">
          <!-- {{scope.row}} -->
                <span
            @click="deliverDetail(scope.row)"
            style="color:red;cursor: pointer;"
          >{{scope.row.stock_out_sn?scope.row.total_real_stock_out_num:""}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="production_batch" label="生产批次号" width="180">
      </el-table-column>
      <el-table-column prop="stock_out_num" width='60' label="批号应发数量">
             <template slot-scope="scope">
          <span
            @click="deliverDetail(scope.row)"
            style="color:red;cursor: pointer;"
          >{{scope.row.stock_out_num}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="real_stock_out_num"  width='60' label="批号实发数量"></el-table-column>
      <el-table-column prop="product_sn" width="150" label="产品编号"></el-table-column>
      <el-table-column prop="product_name" width="150" label="产品名称"></el-table-column>
      <el-table-column prop="product_specs" width="180" label="产品规格"></el-table-column>
      <el-table-column prop="product_unit" width="60" label="单位"></el-table-column>
      <el-table-column prop="warehouse_name" width="180" label="发货仓库"></el-table-column>
      <el-table-column prop="production_date"  width="180" label="生产日期"></el-table-column>
      <el-table-column prop="expiring_date"   width="180" label="有效期至"></el-table-column>
      <el-table-column prop="expiring_date"  label="状态">
        <template slot-scope="scope">
                  <span v-if="scope.row.status == 0">未发货</span>
                  <span v-if="scope.row.status == 1">待收货</span>
                  <span v-if="scope.row.status == 2">发货中</span>
                  <span v-if="scope.row.status == 3">待付款</span>
                  <span v-if="scope.row.status == 4">待审核</span>
                  <span v-if="scope.row.status == 5">审核不通过</span>
                  <span v-if="scope.row.status == 6">已完成</span>
                  <span v-if="scope.row.status == 7">已取消</span>
        </template>
      </el-table-column>
      <el-table-column prop="to_address" label="收货地址" fixed="right" width="180"></el-table-column>
      <el-table-column prop="" label="操作" fixed="right" width="180">
        <template slot-scope="scope">
             <!-- 0未发货 1已发货 2 部分发货 -->
              <el-button type="text" size="small" @click="print(scope.row)">打印</el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click="edit(scope.row)"
                    v-if="!(scope.row.status==6&&scope.row.warehousing_confirm==1)"
                  >编辑</el-button>
                  <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.row.status==2&&scope.row.stock_out_num>scope.row.real_stock_out_num"
                    @click="advance(scope.row.stock_out_sn,'1')"
                  >提前结单</el-button>
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.row.status==1&&scope.row.stock_out_num>scope.row.real_stock_out_num"
                    @click="advance(scope.row.stock_out_sn,'0')"
                  >撤销结单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    ></el-pagination>
    <!--选择经销商/门店-->
    <selectRole
      v-if="selectRoleDialog"
      v-on:handleClose="selectRoleDialog = false"
      @pushData="getSelectinfo"
    ></selectRole>
    <!--批量导入-->
    <importData
      v-if="importDataDialog"
      v-on:handleClose="importDataDialog = false"
      @refresh="onSearch"
    ></importData>
    <!--物流码明细-->
    <deliverCodeDialog
      v-if="deliverCodeDialog"
      v-on:handleClose="deliverCodeDialog = false;onSearch()"
      v-on:done="deliverCodeDialog = false;onSearch()"
      :stock_out_sn="stock_out_sn"
    ></deliverCodeDialog>
  </div>
</template>

<script>
import selectRole from "./selectRole";
import importData from "./importData";
import deliverCodeDialog from "./deliverCode";
import handlerTable from '@/until/handlerTable'
export default {
  name: "deliver-manage",
  data() {
    return {
      loading: false,
      selectRoleDialog: false,
      importDataDialog: false,
      deliverCodeDialog: false,
      
      form: {
        start_time: "",
        end_time: "",
        production_batch: "",
        stock_out_sn: "",
        product_sn: "",
        product_name: "",
        warehouse_sn: "",
        status: "",
        to_sn: "",
        to_type: "",
        isgift: ""
      },
      stockArray: [], //仓库
      tableData: [],
      //分页
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      stock_out_sn: "" //传给物流明细
    };
  },
  methods: {
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    //获取仓库
    getStock() {
      this.$get("logistics", "/warehouses.all", {
        lang: ""
      })
        .then(res => {
          this.stockArray = res.data;
        })
        .catch(function() {
        });
    },
    //获取选择经销商门店
    getSelectinfo(val) {
      if (val.dealer_sn) {
        this.form.to_sn = val.dealer_sn;
        this.form.to_type = 2;
      } else {
        this.form.to_sn = val.shop_sn;
        this.form.to_type = 3;
      }
    },
    //请求列表数据
    onSearch() {
      let beginstr = "",
        endstr = "",
        order_line_no_str = '';
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      if( this.form.type == 2 ){
        order_line_no_str= this.form.order_line_no;
      }
      this.loading = true;
      this.$get("logistics", "/outwarehouses", {
        type: this.form.type,
        lang: "",
        start_time: beginstr,
        end_time: endstr,
        product_sn: this.form.product_sn,
        stock_out_sn: this.form.stock_out_sn,
        production_batch: this.form.production_batch,
        product_name: this.form.product_name,
        warehouse_sn: this.form.warehouse_sn,
        to_type: this.form.to_type,
        to_sn: this.form.to_sn,
        status: this.form.status,
        isgift: this.form.isgift,
        order_line_no: order_line_no_str,
        per_page: this.pageSize,
        page: this.pageNo
      })
        .then(res => {
          this.loading = false;
          this.tableData = handlerTable(res.data,{
            keys:'outwarehouse_products'
          },function(element){
            element.total_stock_out_num=element.stock_out_num
            element.total_real_stock_out_num=element.real_stock_out_num
            return element 
          })
       this.totalSize = res.meta.total;
        }).catch(function() {
          // this.loading = false;
        });
    },
    //添加发货
    addDeliver() {
      this.$router.push({
        name: "addDeliver"
      });
    },
    //批量导入
    importData() {
      this.importDataDialog = true;
    },
    //选择经销商/门店
    selectType() {
      this.selectRoleDialog = true;
    },
    //导出
    exportData() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");
      window.open(
         this.$Base_Export+
          "/outwarehouses.export?start_time=" +
          beginstr +
          "&is_export=1" +
          "&end_time=" +
          endstr +
          "&product_sn=" +
          this.form.product_sn +
          "&stock_out_sn=" +
          this.form.stock_out_sn +
          "&production_batch=" +
          this.form.production_batch +
          "&product_name=" +
          this.form.product_name +
          "&lang=" +
          "" +
          "&warehouse_sn=" +
          this.form.warehouse_sn +
          "&to_type=" +
          this.form.to_type +
          "&to_sn=" +
          this.form.to_sn +
          "&status=" +
          this.form.status +
          "&isgift=" +
          this.form.isgift +
          "&signature=" +
          this.$md5(access_tokens)
      );
    },
    //发货标签码明细
    deliverDetail(row) {
      
      this.stock_out_sn = row.stock_out_sn?row.stock_out_sn:row.row_sn;
      this.deliverCodeDialog = true;
    },
    //打印
    print(item) {
      this.$router.push({
        name: "printDeliver",
        query: {
          stock_out_sn: item.stock_out_sn
        }
      });
    },
    //编辑
    edit(item) {
      this.$router.push({
        name: "addDeliver",
        query: {
          stock_out_sn: item.stock_out_sn
        }
      });
    },
    advance(sn, temp) {
      this.$confirm(temp == 1 ? "是否提前结单?" : "是否撤销提前结单", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let url = "/outwarehouses/" + sn + "/advance";
          this.$patch("logistics", url, {
            advance_order_status: temp
          })
            .then(res => {
              this.$message({
                type: "success",
                message: "成功!"
              });
              this.onSearch();
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error.message
              });
            });
        })
        .catch(error => {
          this.$message({
            type: "info",
            message: "取消删除成功!"
          });
        });
    },
    //删除
    del(item) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let url = "/outwarehouses/" + item.stock_out_sn;
          this.$delete("logistics", url, {})
            .then(res => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.onSearch();
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error.message
              });
            });
        })
        .catch(error => {
          this.$message({
            type: "info",
            message: "取消删除成功!"
          });
        
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
    },
  },
  created() {
    this.form.start_time = this.getLastMonth().last;
    this.form.end_time = this.getLastMonth().now;
    this.getStock();
    this.onSearch();
  },
  components: {
    selectRole,
    importData,
    deliverCodeDialog,
  }
};
</script>
<style lang="scss" scoped>
.tableBox {
  // overflow-x: scroll;
  .table {
    // width: 300%;
  }
}
.btnBox {
  margin-top: 0;
}
</style>